import React from 'react';
import { useStoreState } from 'easy-peasy';
import { Accordion } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from 'react-bootstrap/Card';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';



function OtherPaymentOptions() {

    function CustomToggle({ children, eventKey }) {
        const decoratedOnClick = useAccordionButton(eventKey, () =>
          console.log('true'),
        );
      
        return (
          <button
            className='btn btn-block'
            type="button"
            style={{ backgroundColor: setting.brandSettings.BannerBgColor}}
            onClick={decoratedOnClick}
          >
            {children}
          </button>
        );
      }
    
 
    const setting = useStoreState(state => state.siteSettingsModel);
    const ProductName = setting.brandSettings.ProductName === "Fit" ? setting.brandSettings.ProductName.toUpperCase() : setting.brandSettings.ProductName;
 
    return (
        <div className='col-12 mt-3'>
             <Accordion defaultActiveKey="1">
                <Card style={{borderTopLeftRadius: "10px", borderTopRightRadius: "10px"}}>
                    <Card.Header className='p-0'>
                        <CustomToggle eventKey="0">Other Payment Options</CustomToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <div className='col-12'>
                                <div className='row mb-3'>
                                    <div className='col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2'>
                                        <img src='/money-order.png' className='w-100' alt='money order' />
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-12 col-xs-12 mb-2'>
                                        <h3 style={{color : 'black'}}><strong>Make payment by mail with a Check or Money Order</strong></h3>
                                        <p className='pr-0 pl-0'>
                                            Mail your check or money order to {setting.brandSettings.BankName}, Continental Finance, PO Box 8099, Newark, DE 19714-8099. 
                                            Please include your Reference Number in the memo section of your check or money order. Allow seven to ten days mail time for your payment to be received. 
                                            Please note that by using a check to pay your processing fee there will be a delay of up to 10 days before you account can be opened 
                                            to ensure that the funds clear. To avoid any delay please consider choosing the debit, credit, or prepaid card payment option.
                                        </p>
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2'>
                                        <img src='/personal-payment.png' className='w-100' alt='peronal payment' />
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-12 col-xs-12 mb-2'>
                                        <h3 style={{color : 'black'}}><strong>Make payment in person at MoneyGram</strong></h3>
                                        <p className='pr-0 pl-0'>
                                            To make your processing fee payment by MoneyGram you will need to locate the nearest MoneyGram location. To find the office closest to you call 1-800-926-9400. 
                                            Once you arrive at MoneyGram tell the agent that you are making a payment for the {ProductName} Mastercard and give them the following Receive Code 16471. 
                                            Our city is Newark and the two state abbreviation for the state is DE. Please make sure to include your Reference Number on your MoneyGram payment. 
                                            While paying your processing fee with MoneyGram does result in fast access to your new account be advised that 
                                            MoneyGram may charge you a fee for making this payment.
                                        </p>
                                    </div>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2'>
                                        <img src='/westernunion.png' className='w-100' alt='wester union logo' />
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-12 col-xs-12 '>
                                        <h3 style={{color : 'black'}}><strong>Make payment in person at Western Union</strong></h3>
                                        <p className='pr-0 pl-0'>
                                            To make your processing fee payment by Western Union you will need to locate the nearest Western Union location. 
                                            To find the office closest to you call 1-800-325-6000 . Once you arrive at Western Union tell the agent that you are making a payment for the 
                                            {ProductName} Mastercard and give them the following Send to: Continental Processing. City Code: CFCProcessingDE and the two letter state abbreviation for the state is DE. 
                                            Please make sure to include your Reference Number on your Western Union payment. While paying your processing fee with 
                                            Western Union does result in fast access to your new account be advised that Western Union may charge you a fee for making this payment.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </div>
    );

}

export default OtherPaymentOptions;